import { ILod } from "interface";
import { ReactNode, createContext, useContext, useState } from "react";

interface AuthContextType {
  isLogin: boolean;
  setIsLogin: (isLogin: boolean) => void;
  viewPort: IViewPort | null;
  setViewPorot: (setViewPorot: IViewPort | null) => void;
  lodInf: ILodInfo | null;
  setLodInf: (lodInf: ILodInfo | null) => void;
  userInf: any;
  setUserInf: (userInf: any) => void;
  onIsLoggedIn: (isLoggedIn: boolean) => void;
  onUserInf: (inf: any) => void;
}

type IViewPort = {
  height: number;
  width: number;
  screen: "web" | "mb";
};

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined
);

interface IAuthProvider {
  children: ReactNode;
}

interface ILodInfo extends ILod {
  defAdltPerCt?: number;
  defRmCt?: number;
}

export const AuthProvider = ({ children }: IAuthProvider) => {
  //로그인 상태값
  const [isLogin, setIsLogin] = useState<boolean>(() => {
    const stored = sessionStorage.getItem("isLogin");
    return stored === "true"; // 문자열이므로 "true" 체크
  });

  //초기 VIEWPORT 값
  const [viewPort, setViewPorot] = useState<IViewPort | null>(null);

  //숙소 정보
  const [lodInf, setLodInf] = useState<ILodInfo | null>(() => {
    const lodInf = localStorage.getItem("lodInf");
    if (lodInf) {
      return JSON.parse(lodInf);
    }

    return null;
  });

  //로그인 정보
  const [userInf, setUserInf] = useState<any>(() => {
    const userInf = localStorage.getItem("userInf");
    if (userInf) {
      return JSON.parse(userInf);
    }
    return null;
  });

  const onIsLoggedIn = (isLoggedIn: boolean) => {
    setIsLogin(isLoggedIn);
    sessionStorage.setItem("isLogin", isLoggedIn + "");
  };

  const onUserInf = (inf: any) => {
    setUserInf({
      ...userInf,
      ...inf,
    });
    localStorage.setItem(
      "userInf",
      JSON.stringify({
        ...userInf,
        ...inf,
      })
    );
  };

  //api 성공여부
  // const [isLoading, setIsloading] = useState(false);

  return (
    <AuthContext.Provider
      value={{
        isLogin,
        setIsLogin,
        viewPort,
        setViewPorot,
        lodInf,
        setLodInf,
        userInf,
        setUserInf,
        onIsLoggedIn,
        onUserInf,
        // isLoading,
        // setIsloading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuthContext GridProvider 내에서만 사용해야 합니다.");
  }

  return context;
};
